module.exports = __webpack_public_path__ + "img/landing_box41.8e45727a.jpg";